import { Text } from '@dixa/lib-shared-habla';
import { Presence } from 'lib-shared-legacy-types';
import { User } from 'lib-shared-types-api';

import { AwayStatus } from 'apis/presence';
import styles from 'components/presence/components/presenceList.module.scss';
import { PresenceListItem } from 'components/presence/components/presenceListItem';
import { UserPresence } from 'components/presence/reducers/presence';

export type PresenceListSectionProps = {
  title: string;
  presenceList: UserPresence[];
  profile: User;
  ownPresence: Presence;
  awayStatuses: AwayStatus[];
};

export const PresenceListSection = ({
  title,
  presenceList,
  profile,
  ownPresence,
  awayStatuses,
}: PresenceListSectionProps): JSX.Element => (
  <>
    <li className={styles.groupHead}>
      <Text.Paragraph variant="3" color="var(--sidebar-text-color-secondary)">
        {title}
      </Text.Paragraph>
    </li>
    <ul className={styles.list}>
      {presenceList.map((userPresence) => {
        return (
          <PresenceListItem
            key={userPresence.user.id}
            ownPresence={ownPresence}
            ownProfile={profile}
            userPresence={userPresence}
            awayStatuses={awayStatuses}
          />
        );
      })}
    </ul>
  </>
);
